export default {
      id: "icon--chevron-new-usage",
      viewBox: "0 0 10 14",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--chevron-new-usage",
      toString: function () {
        return this.url;
      }
    }